import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { SearchFilter } from "../Models/searchFilter.model";

@Injectable()
export class DataService {
  searchFilter = new SearchFilter();
  private searchStringSource = new BehaviorSubject(this.searchFilter);
  searchString = this.searchStringSource.asObservable();

  private toggleListViewSource = new BehaviorSubject(true);
  showListView = this.toggleListViewSource.asObservable();

  private reloadData = new BehaviorSubject(false);
  reloadGridData = this.reloadData.asObservable();

  constructor() { }

  getSearchString(
    message: string,
    selectedFilters: any,
    selectedGroupBy: string
  ) {
    this.searchFilter.searchText = message;
    this.searchFilter.selectedFilters = selectedFilters;
    if (selectedGroupBy) {
      this.searchFilter.groupBy = selectedGroupBy + ".keyword";
    }
    this.searchStringSource.next(this.searchFilter);
  }

  getShowListView(message: boolean) {
    this.toggleListViewSource.next(message);
  }

  getIsReloadData(message: boolean) {
    this.reloadData.next(message);
  }
}
